// extracted by mini-css-extract-plugin
module.exports = {"form":"UploadInput_form__tnLhF","root":"UploadInput_root__2Hm5O","fileImg":"UploadInput_fileImg__2uM-b"};